<template>
  <div class="table-responsive project-list">
    <table class="table table-striped">
      <thead>
      <tr>
        <th class="col-xs-2 col-md-2 col-lg-3">Project</th>
        <th class="col-xs-2 col-md-2 col-lg-1">Status</th>
        <th class="col-xs-2 col-md-2 col-lg-2">Owner</th>
        <th class="col-xs-2 col-md-2 col-lg-2">Broker</th>
        <th class="col-xs-2 col-md-2 col-lg-2">Workflow</th>
        <th class="col-xs-2 col-md-2 col-lg-2">Modified</th>
      </tr>
      </thead>

      <tbody v-if="projects">
      <tr v-for="(project, key) in projects" :key="key">
        <td>
          <router-link :to="{name: 'ProjectDetails', params: {id: project.id}}">
            <h5 class="text-info" :title="project.description"> {{project.name}}</h5>
          </router-link>
        </td>
        <td>
          <template v-if="project.workflow_id === 1">
            <div>{{ projectStatus(project) }}</div>
          </template>
          <template v-else>
            <div v-if="project.question">{{project.question.status.name}}</div>
          </template>

        </td>
        <td>
          {{project.owner.firstname}} {{project.owner.lastname}}
        </td>
        <td>
          <template v-if="project.question && project.question.consultant">
            <div>{{project.question.consultant.firstname}} {{project.question.consultant.lastname}}</div>
          </template>
          <template v-else>
            <div>Not defined</div>
          </template>
        </td>
        <td>{{project.workflow.name}}</td>
        <td>{{project.updated_at | moment('LL')}}</td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr>
        <td colspan="7"> Empty List</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
</style>

<script>

export default {
  components: {
  },
  props: ['projects'],
  name: 'RecentlyProjects',
  methods: {
    projectStatus: function (project) {
      let allListEnded = true

      if (typeof project.lists !== 'undefined' && project.lists.length !== 0) {
        project.lists.forEach((list) => {
          let biblio = JSON.parse(list.biblio[0].content)

          let diffMonths = this.$moment().diff(this.$moment(list.biblio[0].updated_at), 'months')

          if (Object.keys(biblio).length !== 0 && diffMonths >= 1 && allListEnded !== false) {
            allListEnded = true
          } else {
            allListEnded = false
          }
        })
      }

      return allListEnded === true ? 'Ended' : 'In progress'
    }
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/RecentlyProjects.vue